import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './car-model';
import { VehiclePart } from '../../enums';
import VehicleStateImg from './vehicle-state-img';
import FrontWindowImg from '../../assets/images/car-model/front_window.png';
import RearWindowImg from '../../assets/images/car-model/rear_window.png';

interface Props extends VehicleModelProps {
  part: VehiclePart;
}

const WINDOW_IMGS = {
  [VehiclePart.Front]: FrontWindowImg,
  [VehiclePart.Rear]: RearWindowImg,
};

const WINDOW_STYLES = {
  [VehiclePart.Front]: 'width: 7.1em; top: -0.4em;',
  [VehiclePart.Rear]: 'width: 6.1em; top: -0.75em; right: 0.05em',
};

class VehicleWindow extends React.Component<Props, any> {
  getVehicleItem = () => `${this.props.part}-window`;

  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler(this.getVehicleItem());
  };

  render() {
    const { className, part, vehicleState } = this.props;
    const vehicleItem = this.getVehicleItem();

    return (
      <VehicleStateImg
        className={`${className} ${vehicleState[vehicleItem]}`}
        src={WINDOW_IMGS[part]}
        onClick={this.clickHandler}
      />
    );
  }
}

const StyledVehicleWindow = styled(VehicleWindow)`
  position: relative;
  z-index: 1;
  ${({ part }) => WINDOW_STYLES[part]};
`;

export default StyledVehicleWindow;
